import { Step, StepLabel, Stepper } from "@mui/material";
import React from "react";

import styles from "./Stepper.module.css";

const StepperComponent = ({ activeStep, steps, width }) => {
  return (
    <div className={styles.stepper__container}>
      <Stepper
        sx={{
          width: `${width}`,
          marginInline: "auto",
          marginBlock: "00px 25px",
          "& .MuiStepIcon-text ,.MuiStepLabel-label": {
            fontSize: "14px",
          },
          "& .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root": {
            fontSize: "20px",
          },
          "& .css-z7uhs0-MuiStepConnector-line": {
            borderTopWidth: "3px",
          },

          "& .css-1bw0nnu-MuiStep-root": {
            paddingInline: "3px",
          },
          "& .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed,.css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-active":
            {
              color: "#253b80",
            },
          "& .css-vnkopk-MuiStepLabel-iconContainer": {
            paddingInline: "2px",
          },
          "& .MuiStepLabel-label": {
            display: "none",
          },
        }}
        activeStep={activeStep}
      >
        {steps.map((label) => {
          const stepProps = {};
          const labelProps = {};

          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};

export default StepperComponent;
